export const VERIFICATION_EXPIRY_DAYS = 365;
